import React, {PureComponent} from 'react';

import LogoSVG from './logo.svg';

export default class Logo extends PureComponent {
  static defaultProps = {
    width: 224,
    height: 28
  };

  render() {
    const {className, width, height} = this.props;

    return (
      <a className={className} href="/">
        <LogoSVG width={width} height={height} />
      </a>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Logo/index.jsx